import { Extension } from '@tiptap/core';
const DaKeyboardSubmit = Extension.create({
    name: 'da-keyboard-submit',
    addKeyboardShortcuts () {
        return {
            'Mod-Enter': ()=>{
                this.editor.emit('do-submit', {});
                return true; // Prevent default behavior
            }
        };
    }
});
export { DaKeyboardSubmit };

//# sourceMappingURL=keyboard-submit.js.map